import { Injectable, Inject } from '@angular/core';
import { City , Departaments} from '../models/missingdata.model';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CityService {

  private Url: string;
  private missingCities: BehaviorSubject<City[]>;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.Url = baseUrl;
    this.missingCities = new BehaviorSubject<City[]>(JSON.parse(localStorage.getItem('missingCities')));
  }

  public get missingCitiesList(): City[] {
    return this.missingCities.value;
  }

  setCities(Cities: City[]) {
    localStorage.setItem('missingCities', JSON.stringify(Cities));
  }

  getCities() {
    return this.http.get<City[]>(this.Url + 'api/cities/')
  }

  saveCities(Cities: City[]) {
    return this.http.post(this.Url + 'api/cities/', Cities)
  }

  getdepartments() {
    return this.http.get<Departaments[]>(this.Url + 'api/cities/GetDepartments')
  }

  updateCity(city: City) {
    return this.http.patch(this.Url + 'api/cities/', city)
  }
}
